import * as React from 'react';

import { Box, type DialogProps, styled } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Loadable from '../loadable';

const TitleIconBox = styled(Box)`
    flex: 1;
    display: flex;
    vertical-align: middle;
    justify-content: flex-end;
`;
const TitleTextBox = styled(Box)`
    display: flex;
    vertical-align: middle;
`;

export type GeneralDialogProps = DialogProps & {
    isLoading?: boolean;
    loadingTitle?: string;
    title?: string;
    icon?: React.JSX.Element;
    actions?: React.JSX.Element;
};

export const GeneralDialog = (props: GeneralDialogProps) => {
    const { title, icon, children, onClose, actions, isLoading, loadingTitle, maxWidth, ...other } = props;

    const handleOnClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (onClose) {
            onClose(event, reason);
        }
    };

    return (
        <Dialog
            aria-describedby="dialog-content"
            aria-labelledby="dialog-title"
            maxWidth={maxWidth ?? 'sm'}
            fullWidth
            onClose={handleOnClose}
            {...other}
        >
            <Loadable isLoading={!!isLoading} title={loadingTitle}>
                {title && (
                    <DialogTitle id="dialog-title">
                        <Box display="flex" width="100%">
                            <TitleTextBox>{title}</TitleTextBox>
                            {icon && <TitleIconBox>{icon}</TitleIconBox>}
                        </Box>
                    </DialogTitle>
                )}
                <DialogContent id="dialog-message">{children}</DialogContent>
                {actions && <DialogActions>{actions}</DialogActions>}
            </Loadable>
        </Dialog>
    );
};
